import React, { useState } from 'react'
import LeadContent from './LeadContent';
import Header from './Header';

function Leads() {
  // Manage shared search state at the container level
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <>
      <Header
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearchModal={showSearchModal}
        setShowSearchModal={setShowSearchModal}
      />
      <LeadContent
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearchModal={showSearchModal}
        setShowSearchModal={setShowSearchModal}
      />
    </>
  )
}

export default Leads